export const SharedMessages = {
  labels: {
    newIndicator: {
      id: 'sharedMessages.Labels.NewIndicator',
      defaultMessage: 'New',
    },
    openNewScreen: {
      id: 'sharedMessages.Labels.OpenNewScreen',
      defaultMessage: 'Opens a new screen.',
    },
    openNewDialog: {
      id: 'sharedMessages.Labels.OpenNewDialog',
      defaultMessage: 'Opens a new dialog.',
    },
  },
  dropdown: {
    languageSelected: {
      id: 'languages.ScreenReader.LanguageSelected',
      defaultMessage: 'Language',
    },
  },
};
